import * as React from 'react';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import * as controller from '../admin/controller'
import { withLocalize, Translate } from "react-localize-redux";

class Admins extends React.Component<any, any> {
  searchString: any

  constructor(props: any) {
    super(props);
    this.state = {
      admins: [],
      adminsFiltered: []
    }
  }

  search() {
      let adminsFiltered = this.state.adminsFiltered
      adminsFiltered = this.state.admins.filter((admin: any) => {
        return admin.name.includes(this.searchString.value.trim())
      })
      this.setState({adminsFiltered})
  }

  loadAdmins() {
    fetch('admins/getAll', {
      method: 'POST'
    }).then(results => {
      return results.json();
    }).then(data => {
        let admins = data.admins
        this.setState({admins, adminsFiltered: admins})
    }).catch(err => {
      //alert(err.message);
    })
  }

  componentDidMount() {

  }

  componentWillMount() {
    this.loadAdmins()
  }

  componentWillUnmount() {
  }


  public render() {
    const columns = [{
      Header: '#',
      accessor: 'id',
      maxWidth: 80,
      resizable: false
    }, {
      Header: this.props.translate("name").toString(),
      accessor: 'name'
    }, {
      Header: this.props.translate("email").toString(),
      accessor: 'email'
    }, {
      Header: this.props.translate("phone").toString(),
      accessor: 'phone'
    }, {
      id: 'privilege',
      Header: this.props.translate("privilege").toString(),
      sortable: false,
      maxWidth: 100,
      resizable: false,
      accessor: (d:any) => d,
      Cell: (row:any) => <div>
        {row.value.privilege == "admin"? (<Translate id="admin.manager"/>) : (<Translate id="admin.editor" />)}
        </div>
      }, {
      id: 'settings',
      Header: this.props.translate("settings").toString(),
      sortable: false,
      maxWidth: 100,
      resizable: false,
      accessor: (d:any) => d,
      Cell: (row:any) => <div>
        <Link to={"/admins/" + row.value.id}><i className="fas fa-edit"></i></Link>
        {window.account.privilege == "admin" && <i onClick={controller.removeAdmin.bind(this, row.value.id, row.index)} className="fas fa-trash-alt"></i>}
      </div>
    }]

    return (
      <div id="admins-root">
        <input className="search" type="text" placeholder={this.props.translate("admin.searchByName").toString()} onChange={this.search.bind(this)} ref={(searchString:any) => this.searchString = searchString} />

        <div className="board">
          <ReactTable
            data={this.state.adminsFiltered}
            columns={columns}
            defaultPageSize={10}
            noDataText={this.props.translate("noResults").toString()}
            nextText={this.props.translate("next").toString()}
            previousText={this.props.translate("previous").toString()}
            rowsText={this.props.translate("rows").toString()}
            pageText={this.props.translate("page").toString()}
            ofText={this.props.translate("of").toString()}
            style={{
              height: "400px",
              textAlign: "center",
              fontSize: "1em",
              position: "centner",
              right: "0",
              left: "0",
              margin: "0 auto"
            }}
            className="-striped -highlight reactTable"
          />
        </div>
      </div>
    )
  }

}

export default withLocalize(Admins)



// WEBPACK FOOTER //
// ./src/pages/admins/Admins.tsx